<script setup lang="ts">
import { SecondaryDataInterface } from "~/types/ContentType";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/vue";
import CaretTitle from "~/components/regularComponents/UIComponents/CaretTitle.vue";

const props = defineProps<{
  contentData: SecondaryDataInterface;
}>();

const breakpoints = {
  319: {
    slidesPerView: 1.2,
    spaceBetween: 14,
  },
  464: {
    slidesPerView: 1.4,
  },
  984: {
    slidesPerView: 2.5,
    spaceBetween: 36,
  },
  1439: {
    slidesPerView: 3.5,
  },
  2559: {
    slidesPerView: 4,
  },
  3839: {
    slidesPerView: 5,
  },
};
</script>
<template>
  <div v-if="contentData?.data?.list" class="partners container">
    <CaretTitle :title="contentData?.conf?.header?.title" no-grid />

    <Swiper :breakpoints="breakpoints" :slidesPerView="1" :spaceBetween="36">
      <SwiperSlide
        v-for="item in contentData.data.list"
        :key="item.id"
        class="partners-item"
      >
        <a :href="item.url.url" target="_blank">
          <div class="partners-item-img-wrapper">
            <div class="partners-item-img">
              <img :src="item.image?.[0]?.devices?.desktop" />
            </div>
          </div>

          <div class="partners-item__bottom">
            <span class="partners-item__bottom-market">
              {{ (item as any)?.market }}
            </span>

            <p class="partners-item__bottom-title">
              {{ item.title }}
            </p>

            <p class="partners-item__bottom-teaser">
              {{ item.teaser }}
            </p>
          </div>
        </a>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<style lang="scss">
.partners {
  &-title {
    font-size: 56px;
    font-weight: 400;
    line-height: 70px;
    text-transform: uppercase;
    margin-bottom: 48px;
  }

  .swiper {
    overflow: visible;
  }

  &-item {
    border: 0.5px solid rgba(0, 0, 0, 0.2);
    padding: 16px;
    cursor: pointer;
    transition: all ease 0.3s;

    a {
      width: 100%;
    }

    &:hover {
      border: 0.5px solid #fecb29;
      background: rgba(31, 31, 31, 0.05);
    }

    &-img {
      position: relative;
      padding-top: 37%;

      &-wrapper {
        padding: 18px;
        background: rgba(31, 31, 31, 0.05);
        margin-bottom: 8px;
      }

      img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__bottom {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 4px 0;

      &-market {
        width: fit-content;
        padding: 8px 16px;
        border: 0.5px solid #fecb29;
        background: rgba(254, 203, 41, 0.15);
      }

      &-title {
        font-size: 24px;
        font-weight: 700;
        line-height: 37px;
        height: 37px;
        @include clamp(1);

        @include maxq(mobile) {
          font-size: 17px;
        }
      }

      &-teaser {
        font-size: 14px;
        font-weight: 400;
        height: 111px;
        line-height: 18px;
        @include clamp(6);
      }
    }
  }
}
</style>
